import React from "react";

type Props = { className?: string; size?: number };

const OptimizelyLogo: React.FC<Props> = ({ className, size = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 77.4 73"
    role="img"
    aria-label="Optimizely"
    className={className}
  >
    <path
      fill="#3BE081"
      d="M25.1,40.1v8.8c6.7,0,13.1-2.6,17.9-7.2s7.4-10.8,7.4-17.3h-9.1c0,4.2-1.7,8.2-4.8,11.1 C33.6,38.4,29.4,40.1,25.1,40.1z"
    />
    <path
      fill="#0037FF"
      d="M25.1,64.3c-4.3,0-8.4-1.6-11.4-4.6c-3-2.9-4.7-6.9-4.7-11c0-4.1,1.7-8.1,4.7-11c3-2.9,7.1-4.6,11.4-4.6v-8.7 c-3.3,0-6.6,0.6-9.6,1.8c-3,1.2-5.8,3-8.2,5.3s-4.2,4.9-5.5,7.9c-1.3,3-1.9,6.1-1.9,9.3s0.6,6.4,1.9,9.3c1.3,3,3.1,5.6,5.4,7.9 c2.3,2.3,5.1,4.1,8.1,5.3c3,1.2,6.3,1.9,9.6,1.9h0.1V64.3z"
    />
    <path
      fill="#00CCFF"
      d="M25.1,64.3V73c6.7,0,13-2.6,17.7-7.1s7.4-10.8,7.4-17.2h-9c0,4.1-1.7,8.1-4.7,11 C33.5,62.6,29.4,64.3,25.1,64.3z"
    />
    <path
      fill="#861DFF"
      d="M25.1,15.6v8.7c6.7,0,13-2.6,17.7-7.1c4.7-4.6,7.4-10.8,7.4-17.2h-9c0,4.1-1.7,8.1-4.7,11 C33.5,14,29.4,15.6,25.1,15.6z"
    />
    <path
      fill="#FF8110"
      d="M52.3,16.9v8.7c6.7,0,13-2.6,17.7-7.1c4.7-4.6,7.4-10.8,7.4-17.2h-9c0,4.1-1.7,8.1-4.7,11 C60.6,15.2,56.6,16.9,52.3,16.9z"
    />
  </svg>
);

export default OptimizelyLogo;
